// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AuthLoginPage from "./AuthLoginPage.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function get(values, field) {
  return values.email;
}
function set(values, field, value) {
  return {
    email: value
  };
}
let LoginRecoveryFormLenses_ = {
  get: get,
  set: set
};
let LoginRecoveryFormLenses = {
  get: get,
  set: set
};
let LoginRecoveryForm = Form.Make(LoginRecoveryFormLenses);
let styles = {
  root: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "marginTop-keoZOQ": "marginTop-x12fpr9t",
    "width-kzqmXN": "width-x2cbyk5",
    $$css: "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:41"
  },
  title: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "paddingBlock-k8WAf4": "paddingBlock-xqp6ajr",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:50"
  },
  subtitle: {
    "color-kMwMTN": "color-x1wohto9",
    "font-kVVagm": "font-xyeg6z0",
    "lineHeight-kLWn49": "lineHeight-xdod15v",
    "textAlign-k9WMMc": "textAlign-x2b8uid",
    "backgroundColor-kWkggS": "backgroundColor-xhb2u9n",
    "marginInline-kUOVxO": "marginInline-x10a08wb",
    "marginBlock-kqGvvJ": "marginBlock-x1twdi5u",
    $$css: "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:57"
  }
};
function styleProps() {
  return {
    className: "alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k marginTop-x12fpr9t width-x2cbyk5",
    "data-style-src": "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:41"
  };
}
function titleStyleProps() {
  return {
    className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf paddingBlock-xqp6ajr width-xh8yej3",
    "data-style-src": "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:50"
  };
}
function subtitleStyleProps() {
  return {
    className: "color-x1wohto9 font-xyeg6z0 lineHeight-xdod15v textAlign-x2b8uid backgroundColor-xhb2u9n marginInline-x10a08wb marginBlock-x1twdi5u",
    "data-style-src": "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:57"
  };
}
let endpoint = Env.gatewayUrl() + "/auth/password-forgot";
function encodeBody(username) {
  return Json.encodeDict(Object.fromEntries([["username", Json.encodeString(username)]]));
}
function make(username) {
  return Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeBody(username)
  }, false, undefined);
}
let PasswordRecoveryRequest = {
  endpoint: endpoint,
  encodeBody: encodeBody,
  make: make
};
let schema = [{
  TAG: "Email",
  _0: "Email"
}];
function AuthLoginRecoveryPage(props) {
  let passwordRecoveryRequest = props.passwordRecoveryRequest;
  let loginRecoveryEmailSentRoute = props.loginRecoveryEmailSentRoute;
  let match = React.useState(() => {});
  let setNotfication = match[1];
  let notification = match[0];
  let onSubmit = (param, param$1) => Future.mapError(Future.mapOk(passwordRecoveryRequest(param$1.email), undefined, param => I18n.t("You should have received the recovery link by the next minutes.")), undefined, param => I18n.t("An unexpected error occured. Please try again or contact the support."));
  let navigate = Navigation.useNavigate();
  let onSubmitSuccess = res => {
    if (res !== undefined) {
      return navigate(undefined, loginRecoveryEmailSentRoute);
    } else {
      return setNotfication(param => ({
        TAG: "Danger",
        _0: I18n.t("An unexpected error occured. Please try again or contact the support.")
      }));
    }
  };
  let onSubmitFailure = error => setNotfication(param => ({
    TAG: "Danger",
    _0: error
  }));
  let formPropState = LoginRecoveryForm.useFormPropState({
    initialValues: {
      email: ""
    },
    schema: schema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let onRequestCloseNotificationBanner = () => setNotfication(param => {});
  let match$1 = {
    className: "alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k marginTop-x12fpr9t width-x2cbyk5",
    "data-style-src": "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:41"
  };
  let match$2 = {
    className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf paddingBlock-xqp6ajr width-xh8yej3",
    "data-style-src": "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:50"
  };
  let match$3 = {
    className: "color-x1wohto9 font-xyeg6z0 lineHeight-xdod15v textAlign-x2b8uid backgroundColor-xhb2u9n marginInline-x10a08wb marginBlock-x1twdi5u",
    "data-style-src": "wino-gc:src/app/Auth/AuthLoginRecoveryPage.res.js:57"
  };
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsxs("div", {
      children: [JsxRuntime.jsx(Title.make, {
        children: I18n.t("Recover your password"),
        level: 2,
        align: "center"
      }), notification !== undefined ? JsxRuntime.jsx(AuthLoginPage.NotificationBanner.make, {
        notification: notification,
        onRequestClose: onRequestCloseNotificationBanner
      }) : null, JsxRuntime.jsx("span", {
        children: I18n.t("Type the email address associated with your account, and we will send you a link to reset your password. If you don’t receive the email, please check your spam folder. If no email arrives, it means there is no account associated with that address."),
        className: match$3.className,
        style: match$3.style
      })],
      className: match$2.className,
      style: match$2.style
    }), JsxRuntime.jsxs(LoginRecoveryForm.Core.Provider.make, {
      children: [JsxRuntime.jsx(LoginRecoveryForm.ControlEnterKey.make, {
        onSubmit: onSubmit
      }), JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(LoginRecoveryForm.InputText.make, {
          field: "Email",
          label: I18n.t("Email address"),
          placeholder: I18n.t("name@yourcompany.com"),
          hideRequired: true
        }), JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(LoginRecoveryForm.SubmitButton.make, {
            label: I18n.t("Send a recovery link"),
            onSubmit: onSubmit
          }),
          spaceY: "xsmall"
        })],
        space: "large"
      })],
      propState: formPropState
    })],
    className: match$1.className,
    style: match$1.style
  });
}
let passwordRecoveryRequest = make;
let make$1 = AuthLoginRecoveryPage;
export { LoginRecoveryFormLenses_, LoginRecoveryFormLenses, LoginRecoveryForm, styles, styleProps, titleStyleProps, subtitleStyleProps, PasswordRecoveryRequest, passwordRecoveryRequest, schema, make$1 as make };
/* LoginRecoveryForm Not a pure module */